"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIs = exports.isLimitedDataSize = void 0;
var getByteLength_1 = require("../utils/getByteLength");
/**
 * https://fetch.spec.whatwg.org/#http-network-or-cache-fetch > 8.10.5
 * If payload is greather than 64 kibibytes, request will be rejected by browser with a 0-status response with fetch 'keepalive' and sendBeacon
*/
var DATA_SIZE_LIMIT = 65536;
var DATA_SIZE_LIGHT = 32768;
function isLimitedDataSize(str) {
    // string length already greather than inflightKeepaliveBytes length limit
    if (str.length > DATA_SIZE_LIMIT) {
        return false;
    }
    if (str.length <= DATA_SIZE_LIGHT) {
        return true;
    }
    return (0, getByteLength_1.getByteLength)(str) <= DATA_SIZE_LIMIT;
}
exports.isLimitedDataSize = isLimitedDataSize;
exports.APIs = {
    inited: false,
    supportFetch: typeof window.fetch === 'function',
    /** 支持fetch keepalive  */
    supportFetchKeepAlive: typeof window.fetch === 'function' && 'keepalive' in new Request(''),
    supportSendBeacon: typeof (navigator === null || navigator === void 0 ? void 0 : navigator.sendBeacon) === 'function',
    isLimitedDataSize: function (data) {
        return data.byteLength <= DATA_SIZE_LIMIT;
    },
    ensureKeepaliveFetch: function (url, token) {
        return __awaiter(this, void 0, void 0, function () {
            var checkReq, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        /**
                         * Ensure keepalive support.
                         * Preflight request might be aborted in chromium
                         * Ref - https://bugs.chromium.org/p/chromium/issues/detail?id=835821
                         */
                        if (exports.APIs.inited || localStorage.getItem("mdap_support_fetch") === url) {
                            return [2 /*return*/, exports.APIs.supportFetchKeepAlive];
                        }
                        exports.APIs.inited = true;
                        if (!exports.APIs.supportFetchKeepAlive) {
                            return [2 /*return*/, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(url, {
                                method: 'HEAD',
                                headers: {
                                    'x-mdap-preflight': 'ensure',
                                    Authorization: "Bearer " + token
                                },
                                keepalive: true
                            })];
                    case 2:
                        checkReq = _a.sent();
                        if (checkReq.status === 200) {
                            localStorage.setItem("mdap_support_fetch", url);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        exports.APIs.supportFetchKeepAlive = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, exports.APIs.supportFetchKeepAlive];
                }
            });
        });
    },
    get: function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var xhr = new XMLHttpRequest();
                        xhr.open('GET', url);
                        xhr.onreadystatechange = function () {
                            if (xhr.readyState === XMLHttpRequest.DONE) {
                                if (xhr.status === 200) {
                                    return resolve(xhr.response);
                                }
                                else {
                                    return reject(xhr.response);
                                }
                            }
                        };
                        xhr.send();
                    })];
            });
        });
    },
    post: function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data, token, res, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = props.url, data = props.data, token = props.token;
                        if (!this.supportFetch) return [3 /*break*/, 3];
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: __assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, (token ? {
                                    Authorization: "Bearer " + token
                                } : {})),
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2:
                        response = _a.sent();
                        if (res.status === 200) {
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/, Promise.reject(response)];
                    case 3: return [2 /*return*/, this.postXHR(props)];
                }
            });
        });
    },
    sendBeacon: function (props) {
        if (this.supportSendBeacon) {
            var url = props.url, reportData = props.data;
            var formData = new FormData();
            var data = reportData.data, commonData = __rest(reportData, ["data"]);
            for (var _i = 0, _a = Object.keys(commonData); _i < _a.length; _i++) {
                var key = _a[_i];
                var value = commonData[key];
                value = typeof value === 'string' ? value : JSON.stringify(value);
                formData.append(key, value !== null && value !== void 0 ? value : 'unknown');
            }
            formData.append('data', JSON.stringify(data));
            return navigator.sendBeacon(url, formData);
        }
        return false;
    },
    /** fetch with keepalive: true */
    fetchPost: function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data, token, dataStr, useKeepalive, res, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = props.url, data = props.data, token = props.token;
                        if (!this.supportFetchKeepAlive) return [3 /*break*/, 3];
                        dataStr = JSON.stringify(data);
                        useKeepalive = isLimitedDataSize(dataStr);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: __assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, (token ? {
                                    Authorization: "Bearer " + token
                                } : {})),
                                keepalive: useKeepalive,
                                body: dataStr
                            })];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2:
                        response = _a.sent();
                        if (res.status === 200) {
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/, Promise.reject(response)];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    },
    /** fallback - xhr */
    postXHR: function (props) {
        var url = props.url, data = props.data, _a = props.async, async = _a === void 0 ? true : _a, token = props.token;
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, async);
            xhr.setRequestHeader('Content-Type', 'application/json');
            if (token) {
                xhr.setRequestHeader('Authorization', "Bearer " + token);
            }
            xhr.addEventListener('readystatechange', function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        var result = xhr.response;
                        try {
                            result = JSON.parse(result);
                        }
                        catch (error) {
                            // 
                        }
                        return resolve(result);
                    }
                    else {
                        return reject(xhr.response);
                    }
                }
            });
            xhr.send(JSON.stringify(data));
        });
    },
    /** fetch with keepalive: true */
    fetchPostCipher: function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data, token, secretKey, secretKeyVersion, res, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = props.url, data = props.data, token = props.token, secretKey = props.secretKey, secretKeyVersion = props.secretKeyVersion;
                        if (!this.supportFetchKeepAlive) return [3 /*break*/, 3];
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/octet-stream',
                                    Accept: 'application/json',
                                    Authorization: "Bearer " + token,
                                    'x-mdap-encrypted-key': secretKey,
                                    'x-mdap-algkey-version': "v1;" + secretKeyVersion
                                },
                                keepalive: true,
                                body: data
                            })];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2:
                        response = _a.sent();
                        if (res.status === 200) {
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/, Promise.reject(response)];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    },
    sendBeaconCipher: function (props) {
        if (this.supportSendBeacon) {
            var url = props.url, data = props.data;
            return navigator.sendBeacon(url, data);
        }
        return false;
    },
    postCipher: function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data, token, secretKey, secretKeyVersion, res, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = props.url, data = props.data, token = props.token, secretKey = props.secretKey, secretKeyVersion = props.secretKeyVersion;
                        if (!this.supportFetch) return [3 /*break*/, 3];
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/octet-stream',
                                    Accept: 'application/json',
                                    Authorization: "Bearer " + token,
                                    'x-mdap-encrypted-key': secretKey,
                                    'x-mdap-algkey-version': "v1;" + secretKeyVersion
                                },
                                body: data
                            })];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2:
                        response = _a.sent();
                        if (res.status === 200) {
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/, Promise.reject(response)];
                    case 3: return [2 /*return*/, this.postXHRCipher(props)];
                }
            });
        });
    },
    postXHRCipher: function (props) {
        var url = props.url, data = props.data, secretKey = props.secretKey, token = props.token, secretKeyVersion = props.secretKeyVersion;
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url);
            xhr.setRequestHeader('Authorization', "Bearer " + token);
            xhr.setRequestHeader('x-mdap-encrypted-key', secretKey);
            xhr.setRequestHeader('x-mdap-algkey-version', "v1;" + secretKeyVersion);
            xhr.addEventListener('readystatechange', function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        var result = xhr.response;
                        try {
                            result = JSON.parse(result);
                        }
                        catch (error) {
                            // 
                        }
                        return resolve(result);
                    }
                    else {
                        return reject(xhr.response);
                    }
                }
            });
            xhr.send(new Uint8Array(data));
        });
    },
};
